import { actionTypes } from '.'

const localStorageKey = 'userAddress'

const initialState = {
	userAddress: null,
	userAddresses: null
}

const reducer = (state = initialState, action) => {
  const localStorageData = JSON.parse(localStorage.getItem(localStorageKey)) || {}
  const loadedState = {
    ...state,
    ...localStorageData
  }

  const newState = {
    value: loadedState
  }

  switch (action.type) {
    case actionTypes.SET_USER_ADDRESS:
      Object.assign(newState, {
        value: {
          ...newState.value,
          userAddress: action.payload
        }
      })

      break

		case actionTypes.SET_USER_ADDRESSES:
			Object.assign(newState, {
				value: {
					...newState.value,
					userAddresses: action.payload
				}
			})

			break

		case actionTypes.REMOVE_USER_ADDRESSES_ITEM:
			const filteredUserAddresses = newState.value.userAddresses.filter(filteredItem => filteredItem.id !== action.payload.id)

			Object.assign(newState, {
				value: {
					...newState.value,
					userAddresses: [
						...filteredUserAddresses
					]
				}
			})

			break

    default:
  }

  localStorage.setItem(localStorageKey, JSON.stringify(newState.value))

  return newState.value
}

export default reducer
